import { useEffect, useState } from 'react';
import { Radio, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import SeoHelmet from '../../common/SeoHelmet';
import './NewsList.css';
import { getNewsListFromLinyuan } from '../../../common/javascripts/common.js';

export default function NewsList(props) {
  const [newsList, setNewsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [newsType, setNewsType] = useState(1);
  const [itemsPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const {lang} = props;
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      try {
        const langValue = lang ? 1 : 0;
        const page = await getNewsListFromLinyuan(currentPage, itemsPerPage, newsType, langValue);
        setNewsList(page.list || []);
        const total = page.totalCount || 0;
        const size = page.pageSize || itemsPerPage;
        setTotalPages(Math.max(1, Math.ceil(total / size)));
      } catch (e) {
        console.error('Error fetching news list from linyuanApi', e);
        const msg = lang ? 'Failed to load news, please try again later' : '加载新闻列表失败，请稍后重试';
        message.error(msg);
        setNewsList([]);
        setTotalPages(1);
      }
    }
    load();
  }, [currentPage, newsType, itemsPerPage, lang]);

  const listTitle = lang ? 'Information & Knowledge' : '新闻与资讯';
  const listType = lang ? ['company News', 'Industry Knowledge'] : ['公司新闻', '行业资讯'];

  const typeOptions = [
    { label: listType[0], value: 1, className: 'label-1' },
    { label: listType[1], value: 2, className: 'label-2' },
  ];
  const handleTypeChange = (e) => {
    setNewsType(e.target.value);
  };

  return (
    <div className="news-list-container">
      <SeoHelmet 
        titleCn="新闻与讯息" 
        titleEn="Information" 
        lang={lang} 
        extraKeywords={lang ? ["News", "Industry Knowledge"] : ["新闻", "行业资讯"]}
      />
      <h2>{listTitle}</h2>
      <Radio.Group options={typeOptions} value={newsType} optionType="button" buttonStyle="solid" onChange={handleTypeChange} />
      <div className="newsCards">
        {newsList.map(news => {
          const { id, title, coverUrl, contentHtmlUrl, summary, type: typeValue, publicationDate } = news;
          const type = typeValue === 1 ? listType[0] : listType[1];
          
          const handleCardClick = () => {
            if (contentHtmlUrl) {
              const detailPath = lang ? '/news_en/contents/' : '/news_cn/contents/';
              navigate(detailPath + id);
            }
          };

          return (
            <div 
              className="cardContainer" 
              key={id} 
              onClick={handleCardClick}
              style={{ cursor: contentHtmlUrl ? 'pointer' : 'default' }}
            >
              {coverUrl && (
                <img src={coverUrl} alt={title} />
              )}
              <h3>
                {title}
              </h3>
              <div>
                <span>{type}</span>
                <span>{new Date(publicationDate).toLocaleDateString()}</span>
              </div>
              
            </div>
          )
        })}
      </div>
      <div className="pagination">
        {Array.from({ length: totalPages }, (_, index) => (
          <button key={index} onClick={() => setCurrentPage(index + 1)} className={currentPage === index + 1 ? 'disabled' : ''}>
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
}
